module.exports = __webpack_public_path__ + "img/partially-approved.396e7c4b.svg";